import React, { useState } from "react";
import { Button, Grid, TextField, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import PhoneIphoneOutlinedIcon from "@material-ui/icons/PhoneIphoneOutlined";
import EmailOutlinedIcon from "@material-ui/icons/EmailOutlined";
import RoomOutlinedIcon from "@material-ui/icons/RoomOutlined";
import SendIcon from "@material-ui/icons/Send";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import TelegramIcon from "@material-ui/icons/Telegram";

import Title from "../components/title";
import { getTranslate } from "../localization";

const FORM_ENDPOINT = "https://formsubmit.co/ajax/mehditalebi9675@gmail.com";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "100vh",
    padding: "52px 44px 90px",
    direction: theme.direction,
    textAlign: theme.direction === "rtl" ? "right" : "left",
    [theme.breakpoints.down("sm")]: { padding: "34px 22px 64px" },
    [theme.breakpoints.down("xs")]: { padding: "28px 16px 56px" },
  },
  inner: {
    width: "min(100%, 1220px)",
    margin: "0 auto",
  },
  card: {
    height: "100%",
    minWidth: 0,
    padding: 24,
    borderRadius: 22,
    background: "linear-gradient(145deg,rgba(14,25,48,.92),rgba(8,16,31,.97))",
    border: "1px solid rgba(101,121,165,.16)",
    boxShadow: "0 16px 40px rgba(0,0,0,.17)",
    [theme.breakpoints.down("xs")]: { padding: 17, borderRadius: 18 },
  },
  title: {
    color: "#f5f8fc",
    fontWeight: 850,
    fontSize: "clamp(1.25rem,2.1vw,1.65rem)",
    marginBottom: 9,
    textAlign: theme.direction === "rtl" ? "right" : "left",
  },
  lead: {
    color: "#8e9bb0",
    fontSize: 13,
    lineHeight: 1.95,
    marginBottom: 22,
    maxWidth: 680,
  },
  fields: {
    display: "grid",
    gridTemplateColumns: "repeat(2,minmax(0,1fr))",
    gap: 13,
    [theme.breakpoints.down("sm")]: { gridTemplateColumns: "1fr" },
  },
  fieldFull: { gridColumn: "1 / -1" },
  field: {
    "& .MuiOutlinedInput-root": {
      color: "#e7edf6",
      borderRadius: 13,
      background: "rgba(255,255,255,.018)",
      transition: "background-color .2s ease",
      "& fieldset": { borderColor: "rgba(111,131,174,.16)" },
      "&:hover fieldset": { borderColor: "rgba(22,139,255,.31)" },
      "&.Mui-focused": { background: "rgba(22,139,255,.025)" },
      "&.Mui-focused fieldset": { borderColor: "#168bff", borderWidth: 1 },
    },
    "& .MuiInputBase-input, & textarea": {
      fontSize: 13,
      lineHeight: 1.7,
      textAlign: theme.direction === "rtl" ? "right" : "left",
    },
    "& .MuiInputLabel-root": {
      color: "#6f7f96",
      fontSize: 12,
      transformOrigin: theme.direction === "rtl" ? "top right" : "top left",
    },
    "& .MuiInputLabel-root.Mui-focused": { color: "#5aafff" },
  },
  submitRow: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 12,
    marginTop: 17,
  },
  submit: {
    minHeight: 46,
    minWidth: 142,
    borderRadius: 11,
    padding: "8px 20px",
    color: "#fff",
    fontSize: 11,
    fontWeight: 800,
    background: "linear-gradient(135deg,#168bff,#2e9cff)",
    boxShadow: "0 10px 28px rgba(22,139,255,.20)",
    "&:hover": {
      transform: "translateY(-2px)",
      background: "linear-gradient(135deg,#2495ff,#52b2ff)",
      boxShadow: "0 15px 34px rgba(22,139,255,.27)",
    },
    "&.Mui-disabled": { color: "rgba(255,255,255,.60)" },
  },
  buttonInner: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 9,
    width: "100%",
    direction: theme.direction,
  },
  sendIcon: {
    transform: theme.direction === "rtl" ? "scaleX(-1)" : "none",
  },
  status: {
    padding: "9px 12px",
    borderRadius: 9,
    fontSize: 11,
    lineHeight: 1.6,
  },
  success: {
    color: "#77dab4",
    background: "rgba(16,185,129,.07)",
    border: "1px solid rgba(16,185,129,.18)",
  },
  error: {
    color: "#ff9d9d",
    background: "rgba(239,68,68,.07)",
    border: "1px solid rgba(239,68,68,.18)",
  },
  infoList: {
    display: "flex",
    flexDirection: "column",
    gap: 11,
  },
  info: {
    display: "flex",
    alignItems: "center",
    gap: 13,
    minWidth: 0,
    padding: 15,
    borderRadius: 15,
    background: "rgba(255,255,255,.018)",
    border: "1px solid rgba(148,163,184,.095)",
    direction: theme.direction,
  },
  iconBox: {
    width: 46,
    height: 46,
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 13,
    color: "#2998ff",
    background: "rgba(22,139,255,.07)",
    border: "1px solid rgba(22,139,255,.14)",
  },
  infoLabel: {
    color: "#748298",
    fontSize: 10,
    marginBottom: 3,
  },
  infoValue: {
    minWidth: 0,
    color: "#e1e8f1",
    fontSize: 12,
    fontWeight: 700,
    lineHeight: 1.6,
    overflowWrap: "anywhere",
  },
  socialLinks: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 10,
    marginTop: 16,
    [theme.breakpoints.down("xs")]: { gridTemplateColumns: "1fr" },
  },
  socialLink: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    minHeight: 43,
    padding: "8px 12px",
    borderRadius: 11,
    color: "#aebdd1",
    fontSize: 10.5,
    fontWeight: 750,
    border: "1px solid rgba(148,163,184,.13)",
    background: "rgba(255,255,255,.018)",
    transition: "color .2s ease, border-color .2s ease, transform .2s ease, background-color .2s ease",
    "&:hover": {
      color: "#fff",
      transform: "translateY(-2px)",
      borderColor: "rgba(22,139,255,.30)",
      background: "rgba(22,139,255,.05)",
    },
  },
}));

export default function ContactScreen() {
  const classes = useStyles();
  const translate = getTranslate();
  const [status, setStatus] = useState("idle");

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    setStatus("sending");

    try {
      const formData = new FormData(form);
      formData.append("_subject", "New message from MehdiTalebi.com");
      formData.append("_captcha", "false");
      formData.append("_template", "table");
      formData.append("_replyto", formData.get("email"));

      const response = await fetch(FORM_ENDPOINT, {
        method: "POST",
        headers: { Accept: "application/json" },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Form submission failed");
      }

      form.reset();
      setStatus("success");
    } catch (error) {
      setStatus("error");
    }
  };

  return (
    <div className={`${classes.root} modern-page`}>
      <div className={classes.inner}>
        <Title title={translate.contactme} eyebrow={translate.contactEyebrow} />

        <Grid container spacing={3} alignItems="stretch">
          <Grid item xs={12} lg={7}>
            <div className={classes.card}>
              <Typography component="h2" className={classes.title}>{translate.getintouch}</Typography>
              <div className={classes.lead}>{translate.contactLead}</div>

              <form onSubmit={handleSubmit}>
                <input type="text" name="_honey" tabIndex="-1" autoComplete="off" style={{ display: "none" }} />

                <div className={classes.fields}>
                  <TextField required name="name" label={translate.entername} variant="outlined" className={classes.field} inputProps={{ dir: translate.locale === "fa" ? "rtl" : "ltr" }} />
                  <TextField required type="email" name="email" label={translate.enteremail} variant="outlined" className={classes.field} inputProps={{ dir: "ltr" }} />
                  <TextField required name="subject" label={translate.entersubject} variant="outlined" className={`${classes.field} ${classes.fieldFull}`} inputProps={{ dir: translate.locale === "fa" ? "rtl" : "ltr" }} />
                  <TextField required multiline rows={7} name="message" label={translate.entermessage} variant="outlined" className={`${classes.field} ${classes.fieldFull}`} inputProps={{ dir: translate.locale === "fa" ? "rtl" : "ltr" }} />
                </div>

                <div className={classes.submitRow}>
                  <Button type="submit" disabled={status === "sending"} className={classes.submit}>
                    <span className={classes.buttonInner}>
                      <span>{status === "sending" ? translate.sending : translate.sendmessage}</span>
                      <SendIcon className={classes.sendIcon} fontSize="small" />
                    </span>
                  </Button>

                  <div aria-live="polite">
                    {status === "success" ? <div className={`${classes.status} ${classes.success}`}>{translate.messageSent}</div> : null}
                    {status === "error" ? <div className={`${classes.status} ${classes.error}`}>{translate.messageError}</div> : null}
                  </div>
                </div>
              </form>
            </div>
          </Grid>

          <Grid item xs={12} lg={5}>
            <div className={classes.card}>
              <Typography component="h2" className={classes.title}>{translate.contactInfoTitle}</Typography>
              <div className={classes.lead}>{translate.contactInfoLead}</div>

              <div className={classes.infoList}>
                <div className={classes.info}>
                  <div className={classes.iconBox}><PhoneIphoneOutlinedIcon /></div>
                  <div><div className={classes.infoLabel}>{translate.phone}</div><div className={classes.infoValue}>{translate.tel}</div></div>
                </div>

                <div className={classes.info}>
                  <div className={classes.iconBox}><EmailOutlinedIcon /></div>
                  <div><div className={classes.infoLabel}>{translate.email}</div><div className={classes.infoValue}>mehditalebi9675@gmail.com</div></div>
                </div>

                <div className={classes.info}>
                  <div className={classes.iconBox}><RoomOutlinedIcon /></div>
                  <div><div className={classes.infoLabel}>{translate.address}</div><div className={classes.infoValue}>{translate.street}</div></div>
                </div>
              </div>

              <div className={classes.socialLinks}>
                <a href="https://www.linkedin.com/in/mehditalebi-/" target="_blank" rel="noopener noreferrer" className={classes.socialLink}><LinkedInIcon fontSize="small" /> LinkedIn</a>
                <a href="https://t.me/Mehdita" target="_blank" rel="noopener noreferrer" className={classes.socialLink}><TelegramIcon fontSize="small" /> Telegram</a>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
